export const AppConfig = {
  Local: {
    apiUrl: 'https://unthsc-profileapi-dev.azurewebsites.net/profileapi/api',
    clientUrl: 'https://localhost:4200',
    aiKey: ''
  },
  Development: {
    apiUrl: 'https://unthsc-profileapi-dev.azurewebsites.net/profileapi/api',
    clientUrl: 'https://localhost:4200',
    aiKey: 'd03be3ba-6da0-4f4c-9353-8120e8a738da'
  },
  Qa: {
    apiUrl: 'https://profileapi.qa.apps.unthsc.edu/profileapi/api',
    clientUrl: 'https://profile.qa.apps.unthsc.edu',
    aiKey: 'd03be3ba-6da0-4f4c-9353-8120e8a738da'
  },
  Uat: {
    apiUrl: 'https://profileapi.uat.apps.unthsc.edu/profileapi/api',
    clientUrl: 'https://profile.uat.apps.unthsc.edu',
    aiKey: 'd03be3ba-6da0-4f4c-9353-8120e8a738da'
  },
  Production: {
    apiUrl: 'https://profileapi.apps.unthsc.edu/profileapi/api',
    clientUrl: 'https://profiles.unthsc.edu',
    aiKey: 'ca4a3809-8803-4992-9ae9-cdd71845a1b4'
  }
};
